import api from './api'
import { defActionSlice } from '../../../helpers/defaultAction'
import { projectReducer } from './reducer'

const { setLoading,
    setLoadingSmetas,
    setLoadingCompare,
    setError,
    getProjectAnalogSuccess,
    getProjectsAnalogSuccess,
    uploadJsonLinesSuccess,
    deleteProjectsAnalogSuccess,
    getObjectSmetasSuccess,
    getPricesSuccess,
    getResourcesSuccess,
    getLimitedCostsSuccess,
    clearDelete,
    getAnalogProjectByIdSuccess,
    getSmetasSuccess,
    getPagePriceByProjectIdSuccess,
    savePtmDescriptionSuccess,
    setLoadingImage,
    getObjectAnalogSucsess,
    uploadObjectFilesSuccess,
    getSchemas,
    clearDictionary,
    createObjCharacteristicSuccess,
    getAnalogObjectsByProjectIdSuccess,
    getAllPtmByObjectIdSuccess,
    getAllPtmDescriptionByObjectIdSuccess,
    setLoadingCost,
    addCompareObject,
    clearCompareObjectSuccess,
    getSummaryCostsSuccess,
    getMinMaxCostsSuccess,
    getExplicationsSuccess,
    clearProjectCreateSuccess,
    getAllProjectFilesSuccess,
    updateAnalogObjectSuccess,
    clearUpdateProject,
} = projectReducer.actions

export const uploadJsonLines = (values) => {
    const defObj = {
        req: setLoading,
        suc: uploadJsonLinesSuccess,
        fail: setError,
        service: {
            params: values,
            func: api.UploadJsonLines
        }
    }

    return defActionSlice(defObj)
}


export const uploadObjectFilesAction = (values) => {
    const defObj = {
        req: setLoadingImage,
        suc: uploadObjectFilesSuccess,
        fail: setError,
        service: {
            params: values,
            func: api.UploadObjectFiles
        }
    }
    return defActionSlice(defObj)
}

export const getProjectAnalogAction = (values) => {

    const defObj = {
        req: setLoading,
        suc: getProjectAnalogSuccess,
        fail: setError,
        service: {
            func: api.getAnalogObjects,
            params: values
        }
    }

    return defActionSlice(defObj)
}
export const getAnalogProjectByIdAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getAnalogProjectByIdSuccess,
        fail: setError,
        service: {
            func: api.getAnalogProjectById,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getObjectSmetasAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getObjectSmetasSuccess,
        fail: setError,
        service: {
            func: api.getObjectSmetas,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getSmetasAction = (values) => {
    const defObj = {
        req: setLoadingSmetas,
        suc: getSmetasSuccess,
        fail: setError,
        service: {
            func: api.getSmetas,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getPricesAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPricesSuccess,
        fail: setError,
        service: {
            func: api.getPrices,
            params: values
        }
    }

    return defActionSlice(defObj)
}
export const getResourcesAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getResourcesSuccess,
        fail: setError,
        service: {
            func: api.getResources,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getSchemasAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getSchemas,
        fail: setError,
        service: {
            func: api.getSchemas,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getLimitedCostsAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getLimitedCostsSuccess,
        fail: setError,
        service: {
            func: api.getLimitedCosts,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getProjectsAnalogsAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getProjectsAnalogSuccess,
        fail: setError,
        service: {
            func: api.getAnalogProjects,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getObjectsAnalogsAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getObjectAnalogSucsess,
        fail: setError,
        service: {
            func: api.getAnalogObjects,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const deleteProjectsAnalogsAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: deleteProjectsAnalogSuccess,
        fail: setError,
        service: {
            func: api.deleteAnalogProjects,
            params: values
        }
    }

    return defActionSlice(defObj)
}


export const clearDeleteAction = () => {
    const defObj = {
        req: clearDelete,
    }

    return defActionSlice(defObj)
}

export const clearDictionaryAction = () => {
    const defObj = {
        req: clearDictionary,
    }

    return defActionSlice(defObj)
}

export const getPagePriceByProjectIdAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPagePriceByProjectIdSuccess,
        fail: setError,
        service: {
            func: api.getPagePriceByProjectId,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const savePtmDescriptionAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: savePtmDescriptionSuccess,
        fail: setError,
        service: {
            func: api.savePtmDescription,
            params: values

        }
    }
    return defActionSlice(defObj)
}

export const createObjCharacteristicAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: createObjCharacteristicSuccess,
        fail: setError,
        service: {
            func: api.createObjCharacteristic,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getAllPtmByObjectIdAction = (values) => {
    const defObj = {
        req: setLoadingCost,
        suc: getAllPtmByObjectIdSuccess,
        fail: setError,
        service: {
            func: api.getAllPtmByObjectId,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getAnalogObjectsByProjectIdAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getAnalogObjectsByProjectIdSuccess,
        fail: setError,
        service: {
            func: api.getAnalogObjectsByProjectId,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getAllPtmDescriptionByObjectIdAction = (values) => {
    const defObj = {
        req: setLoadingCost,
        suc: getAllPtmDescriptionByObjectIdSuccess,
        fail: setError,
        service: {
            func: api.getAllPtmDescriptionByObjectId,
            params: values

        }
    }
    return defActionSlice(defObj)
}

export const addCompareObjectAction = (values) => {
    const defObj = {
        req: addCompareObject,
        reqParams: values
    }
    return defActionSlice(defObj)
}

export const clearCompareObjectAction = () => {
    const defObj = {
        req: clearCompareObjectSuccess,
    }
    return defActionSlice(defObj)
}

export const getSummaryCostsAction = (values) => {
    const defObj = {
        req: setLoadingCompare,
        suc: getSummaryCostsSuccess,
        fail: setError,
        service: {
            func: api.getSummaryCosts,
            params: values

        }
    }
    return defActionSlice(defObj)
}

export const getMinMaxCostsAction = (values) => {
    const defObj = {
        req: setLoadingCompare,
        suc: getMinMaxCostsSuccess,
        fail: setError,
        service: {
            func: api.getMinMaxCosts,
            params: values

        }
    }
    return defActionSlice(defObj)
}

export const getExplicationsAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getExplicationsSuccess,
        fail: setError,
        service: {
            func: api.getExplications,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const getAllProjectFilesAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getAllProjectFilesSuccess,
        fail: setError,
        service: {
            func: api.getAllProjectFiles,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const updateAnalogObjectAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: updateAnalogObjectSuccess,
        fail: setError,
        service: {
            func: api.updateAnalogObject,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const clearUpdateProjectAction = (values) => {
    const defObj = {
        req: clearUpdateProject,
    }
    return defActionSlice(defObj)
}

export const updateAnalogObjectFilesAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: updateAnalogObjectSuccess,
        fail: setError,
        service: {
            func: api.updateAnalogObjectFiles,
            params: values
        }
    }

    return defActionSlice(defObj)
}

export const clearProjectCreateAction = () => {
    const defObj = {
        req: clearProjectCreateSuccess,
    }
    return defActionSlice(defObj)
}